import { Component } from '@angular/core';
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, NavController, NavParams, ViewController } from 'ionic-angular';
import { TPVServices } from '../../../tpv/services';
import { TakeawayServices } from '../../../takeaway/services';
import { HttpClient } from '@angular/common/http';


/**
 * Generated class for the PopupTicketRefund page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-popup-ticket-refund',
  templateUrl: 'popup-ticket-refund.html',
})
export class PopupTicketRefund {
  ticket: any;
  total_partial: number = 0;
  refund_reason: string = "";
  refund_option: string = 'total';

  constructor(
    public globals: Globals,
    public translate: TranslateService,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public tpvServices: TPVServices,
    public takeawayServices: TakeawayServices,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    public navCtrl: NavController) {
    this.ticket = this.navParams.get('ticket');
  }

  close() {
    this.viewCtrl.dismiss();
  }

  async refund() {
    //INIT DATA
    var total_refunded = 0;
    total_refunded = this.ticket.amount;
    this.viewCtrl.dismiss({
      'REFUND': 'SUCCESS',
      'total_refunded': total_refunded,
      'refund_reason': this.refund_reason,
    });
  }

  fullHeight(value) {
    if (value) {
      let cssClasses = {
        'height-100': true,
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'height-100': false,
      }
      return cssClasses;
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/components/popups/popup-ticket-refund/popup-ticket-refund.ts